import { useEmergency } from '../hooks';
import { PanicButton, EmergencyContacts, ShiftRequiredGuard } from '../components';

export const EmergencyPage = () => (
  <ShiftRequiredGuard>
    <EmergencyContent />
  </ShiftRequiredGuard>
);

const EmergencyContent = () => {
  const { contacts, loading, error } = useEmergency();

  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold text-slate-800">Emergencia</h2>
        <p className="text-slate-500 text-sm">Alerta rapida y contactos de emergencia</p>
      </div>

      {error && (
        <div className="p-4 bg-red-50 text-red-700 rounded-xl">
          {error}
        </div>
      )}

      {/* Panic Button */}
      <PanicButton />

      {/* Emergency Contacts */}
      <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
        <h3 className="text-lg font-semibold text-slate-800 mb-4">
          Contactos de Emergencia
        </h3>
        <EmergencyContacts contacts={contacts} loading={loading} />
      </div>
    </div>
  );
};
